import { gql } from '@apollo/client';
import { ErrorMessageInfo } from '@retainerclub/shared-api';

export default gql`
  mutation updatePartnerContactCategory($input: PartnerContactCategoryUpdateInput!) {
    updatePartnerContactCategory(input: $input) {
      clientMutationId
      errorMessages {
        ...ErrorMessageInfo
      }
      partnerContactCategory {
        id
        name
        description
        createdAt
        updatedAt
      }
    }
  }
  ${ErrorMessageInfo}
`;
